import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import classnames from 'classnames'
import ScrollAnimation from 'react-animate-on-scroll'

import UAParser from 'ua-parser-js'

export const isMobile = () =>
  new UAParser().getResult().device.type === 'mobile'
export const isTablet = () =>
  new UAParser().getResult().device.type === 'tablet'

class SectionHeader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      backgroundImage: '',
      width: 0,
      height: 0,
    }
    this.setBackgroundImage = this.setBackgroundImage.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  setBackgroundImage(images) {
    let backgroundImage = ''

    if (images) {
      if (isMobile()) {
        if (this.state.width > this.state.height) {
          backgroundImage = images.desktop
        } else {
          backgroundImage = images.mobile
        }
      } else if (isTablet()) {
        if (this.state.width > this.state.height) {
          backgroundImage = images.desktop
        } else {
          backgroundImage = images.tablet
        }
      } else {
        backgroundImage = images.desktop
      }
    }
    if (this.state.backgroundImage !== backgroundImage) {
      this.setState({ backgroundImage })
    }
  }

  updateWindowDimensions() {
    this.setState(
      {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      () => {
        this.setBackgroundImage(this.props.images)
      }
    )
  }

  render() {
    const {
      theme,
      eyebrow,
      h1,
      title,
      copy,
      link,
      download,
      images,
      icon,
      children,
    } = this.props
    const { backgroundImage } = this.state

    const classNames = classnames('section-header', theme, {
      'has-image': images,
      horizontal: this.state.width > this.state.height,
    })

    return (
      <header
        className={classNames}
        style={
          backgroundImage
            ? {
                backgroundImage:
                  'url("' + require('../images/' + backgroundImage) + '")',
              }
            : null
        }
      >
        <div className="container-wide">
          <ScrollAnimation
            animateIn="monsterSlideIn"
            duration={0.5}
            offset={120}
          >
            {eyebrow && <div className="eyebrow">{eyebrow}</div>}

            {icon && <img src={require('../images/' + icon)} alt='section icon' />}

            {h1 && <h1 dangerouslySetInnerHTML={{ __html: h1 }} />}

            {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}

            {copy && <p dangerouslySetInnerHTML={{ __html: copy }} />}

            {link && (
              <Link
                to={link.href}
                className={'button ' + link.color}
                title={link.label}
              >
                {link.label}
              </Link>
            )}
            {download && (
              <a
                href={download.href}
                download={download.filename}
                target="_blank"
                className="download"
              >
                {download.label}
                <span className="material-icons">save_alt</span>
              </a>
            )}
            {children}
          </ScrollAnimation>
        </div>
      </header>
    )
  }
}

SectionHeader.propTypes = {
  theme: PropTypes.string,
  eyebrow: PropTypes.string,
  h1: PropTypes.string,
  title: PropTypes.string,
  copy: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.shape({
    href: PropTypes.string,
    label: PropTypes.string,
    color: PropTypes.string,
  }),
  download: PropTypes.shape({
    href: PropTypes.string,
    label: PropTypes.string,
    filename: PropTypes.string,
  }),
  images: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string,
  }),
}

export default SectionHeader
